export const fileUploadChecker = (file: string) => {
  const allowType = ["image/gif", "image/png", "image/jpeg", "application/pdf"];

  return !allowType.includes(file);
};
